// Generated by BUCKLESCRIPT VERSION 2.1.0, PLEASE EDIT WITH CARE
'use strict';

var React       = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./Help.css')));

function row(keys, action) {
  return /* array */[
          React.createElement("div", {
                className: "keys"
              }, keys),
          React.createElement("div", {
                className: "colon"
              }, ":"),
          React.createElement("div", {
                className: "action"
              }, action)
        ];
}

var component = ReasonReact.statelessComponent("Help");

function make(visible, _) {
  var newrecord = component.slice();
  newrecord[/* render */9] = (function () {
      if (visible !== 0) {
        return React.createElement("div", {
                    className: "help"
                  }, React.createElement("h2", undefined, "Help"), React.createElement("div", {
                        className: "helpGrid"
                      }, row("Arrow Left / Right", "Move Left / Right"), row("X, Arrow Up", "Rotate Right"), row("Z, CTRL", "Rotate Left"), row("Arrow Down", "Fast Drop"), row("SPACE", "Hard Drop"), React.createElement("div", {
                            className: "keys"
                          }), row("H", "Help"), row("M", "Mute")));
      } else {
        return null;
      }
    });
  return newrecord;
}

exports.row       = row;
exports.component = component;
exports.make      = make;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/components/Help.re
// module id = 27
// module chunks = 0